(function () {
    function getButtons(menuEl) {
        return Array.from(menuEl.querySelectorAll("[data-mb-mega-menu-button]"));
    }

    function getPanelForButton(menuEl, btn) {
        const key = btn.getAttribute("data-mb-mega-menu-button");
        return key ? menuEl.querySelector(`[data-mb-mega-panel="${CSS.escape(key)}"]`) : null;
    }


    function setButtonState(menuEl, btn, isOpen) {
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
        const panel = getPanelForButton(menuEl, btn);
        if (panel) {
            if (isOpen) panel.removeAttribute("hidden");
            else panel.setAttribute("hidden", "");
        }
    }

    function closeAll(menuEl) {
        getButtons(menuEl).forEach((btn) => setButtonState(menuEl, btn, false));
    }

    function openButton(menuEl, btn) {
        getButtons(menuEl).forEach((b) => setButtonState(menuEl, b, b === btn));
    }

    function toggleButton(menuEl, btn) {
        const isOpen = btn.getAttribute("aria-expanded") === "true";
        if (isOpen) closeAll(menuEl);
        else openButton(menuEl, btn);
    }

    function initMegaMenu(menuEl) {
        if (menuEl.dataset.mbMegaMenuInit === "1") return;
        menuEl.dataset.mbMegaMenuInit = "1";

        const openMode = menuEl.dataset.mbMegaOpen || "hover";
        const buttons = getButtons(menuEl);

        let closeTimer = null;
        const closeWithDelay = (ms = 500) => {
            window.clearTimeout(closeTimer);
            closeTimer = window.setTimeout(() => closeAll(menuEl), ms);
        };
        const cancelClose = () => {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        };

        closeAll(menuEl);

        buttons.forEach((btn) => {
            const item = btn.closest("[data-mb-mega-item]");

            if (openMode === "click") {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    cancelClose();
                    toggleButton(menuEl, btn);
                });
            } else {
                btn.addEventListener("mouseenter", () => {
                    cancelClose();
                    openButton(menuEl, btn);
                });
            }

            if (item) {
                item.addEventListener("mouseenter", cancelClose);
                // item.addEventListener("mouseleave", () => closeWithDelay(500));
            }
        });

        // L2 accordion toggles inside panels
        menuEl.querySelectorAll("[data-mb-mega-l2-item]").forEach((item) => {
            const trigger = item.querySelector("[data-mb-mega-l2-trigger]");
            const content = item.querySelector("[data-mb-mega-l3]");
            if (!trigger || !content) return;

            const setOpen = (open) => {
                trigger.setAttribute("aria-expanded", open ? "true" : "false");
                if (open) content.removeAttribute("hidden");
                else content.setAttribute("hidden", "");
            };

            // start closed
            setOpen(false);

            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                const isOpen = trigger.getAttribute("aria-expanded") === "true";
                // single-open behavior inside this panel (optional):
                const list = item.closest("[data-mb-mega-l2]") || item.parentElement;
                (list ? list.querySelectorAll("[data-mb-mega-l2-item]") : []).forEach((sib) => {

                    if (sib === item) return;
                    const t = sib.querySelector("[data-mb-mega-l2-trigger]");
                    const c = sib.querySelector("[data-mb-mega-l3]");
                    if (t && c) {
                        t.setAttribute("aria-expanded", "false");
                        c.setAttribute("hidden", "");
                    }
                });
                setOpen(!isOpen);
            });
        });


        // Esc closes
        menuEl.addEventListener("keydown", (e) => {
            if (e.key === "Escape") closeAll(menuEl);
        });

        // Outside click closes (mostly for click mode)
        document.addEventListener("click", (e) => {
            if (!menuEl.contains(e.target)) closeAll(menuEl);
        });
    }

    function initAll(root) {
        root.querySelectorAll("[data-mb-mega-menu]").forEach(initMegaMenu);
    }

    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
